import React, { useEffect, useState } from 'react';
import Button from '../Button';
import { Textarea } from '../Inputs';
import Pill from '../Pill';
import Modal from './Modal';
import moment from 'moment';
import ModalConfirmation from './ModalConfirmation';
import { monthsAndResourceTypes } from '../../constants/translations';

const GDDKDynamicModal = ({
  t,
  isOpen,
  toggle,
  selectedGDDK,
  editMode,
  editOnClick,
  loading,
}) => {
  const [gddkDesc, setGDDKDesc] = useState(
    selectedGDDK.description ? selectedGDDK.description : ''
  );
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  const translations = monthsAndResourceTypes(t);

  useEffect(() => {
    setGDDKDesc(selectedGDDK.description ? selectedGDDK.description : '');
  }, [selectedGDDK]);

  const handleSaveOnClick = () => {
    editOnClick(selectedGDDK.id, gddkDesc);
    setShowModalConfirmation(false);
  };

  const term = moment(selectedGDDK.term);
  const gddkTerm = moment(selectedGDDK.gddkTerm);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <div className='km__c--modal-gddk'>
          <div className='km__c--modal-gddk-header'>
            {t('pages.default.gddkOperations.descModalTitle')}
          </div>
          <div className='km__c--modal-gddk-body'>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>
                {t('pages.default.certificates.table.organizationName')}
              </div>
              <div style={{ textAlign: 'right' }}>
                {selectedGDDK.organizationName}
              </div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>{t('pages.default.certificates.table.stationName')}</div>
              <div>{selectedGDDK.stationName}</div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>{t('pages.default.certificates.table.resourceType')}</div>
              <div>{translations[selectedGDDK.resourceType]}</div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>
                {t('pages.default.certificates.table.productionPeriod')}
              </div>
              <div>
                {translations[term.month() + 1]} {term.year()}
              </div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>{t('pages.default.gddkOperations.table.gddkPeriod')}</div>
              <div>
                {translations[gddkTerm.month() + 1]} {gddkTerm.year()}
              </div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>
                {t('pages.default.certificates.table.gddkDocumentCount')}
              </div>
              <div className='km__u--text-red-300'>{selectedGDDK.amount}</div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>
                {t('pages.default.certificates.table.debtDocumentCount')}
              </div>
              <div className='km__u--text-red-300'>
                {selectedGDDK.certifiableAmount}
              </div>
            </div>
            <div className='km__c--modal-gddk-content km__u--text_title'>
              <div>{t('pages.default.certificates.table.status')}</div>
              <div>
                <Pill
                  label={
                    selectedGDDK.gddkStatus === 'INITIAL'
                      ? t('pages.default.gddkOperations.table.notCompleted')
                      : t('ui.default.codes.SUCCESSFUL')
                  }
                  type={
                    selectedGDDK.gddkStatus === 'INITIAL'
                      ? 'important'
                      : 'success'
                  }
                />
              </div>
            </div>
            {/* <div className='km__c--modal-gddk-content km__u--text_title'>
                            <Checkbox
                                label={t('pages.default.gddkOperations.partialPassiveTitle')}
                                name='sellerOption'
                                className='km__u--text_title'
                                // checked={sellerOption}
                                onChange={hanldeCheckBoxChange}
                                disabled={!editMode}
                            />
                        </div> */}
            <div className='km__c--modal-gddk-content-desc'>
              <Textarea
                label={t('pages.default.gddkOperations.descModalTitle')}
                name='gddkDesc'
                value={gddkDesc}
                onChange={(e) => setGDDKDesc(e.target.value)}
                disabled={!editMode}
              />
            </div>
          </div>
          <div className='km__c--modal-gddk-footer'>
            <Button
              label={t('ui.default.close')}
              type='secondary'
              onClick={toggle}
            />
            {editMode && (
              <Button
                label={t('ui.default.save')}
                type='primary'
                onClick={() => setShowModalConfirmation(true)}
                disabled={gddkDesc.trim().length < 10}
              />
            )}
          </div>
        </div>
      </Modal>
      <ModalConfirmation
        header={t('pages.default.gddkOperations.editModal.header')}
        body={t('pages.default.gddkOperations.editModal.body')}
        isOpen={showModalConfirmation}
        toggle={() => setShowModalConfirmation(false)}
        approve={handleSaveOnClick}
        loading={loading}
      />
    </>
  );
};

export default GDDKDynamicModal;
